import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbAdminPreCadastro } from 'app/abstract/full-pages/admin-pre-cadastro/admin-pre-cadastro.abstract';
import { AdminPreCadastroDTO } from 'app/models/admin-pre-cadastro-dto.model';
import { AppFilter } from 'app/models/app-filter.model';
import { Pageable } from 'app/models/pageable-mode';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminPreCadastroService extends AbAdminPreCadastro {
  constructor(http: HttpClient) {
    super(http);
  }

  public getAllPreCadastrosInicio(
    filter: AppFilter
  ): Observable<Pageable<AdminPreCadastroDTO>> {
    const endPoint = 'admin/pre_cadastro/dashboard/';
    const filterEncode = filter.encode();

    return this.getAll<Pageable<AdminPreCadastroDTO>>(endPoint, filterEncode);
  }
}
